// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Header, Segment } from 'semantic-ui-react';
import { useOrganization } from '../../hooks/useOrganizations';
import { useUser } from '../../hooks/useUser';

const WEEKDAY_KEYS = [
  'common.weekday.sunday',
  'common.weekday.monday',
  'common.weekday.tuesday',
  'common.weekday.wednesday',
  'common.weekday.thursday',
  'common.weekday.friday',
  'common.weekday.saturday',
] as const;

const PageTitle = () => {
  const { t } = useTranslation();
  const organization = useOrganization();
  const user = useUser();

  const today = t(WEEKDAY_KEYS[moment().day()]);

  return (
    <Segment basic clearing>
      <Header sub style={{ marginTop: '1em' }} content={organization?.name ?? ''} />

      <Header
        as="h1"
        style={{ marginTop: 0 }}
        content={t('dashboard.header.greeting', {
          today,
          name: user && user.firstName,
        })}
      />
    </Segment>
  );
};

const DashboardHeader = () => {
  return (
    <div className="px-4">
      <div className="container mx-auto">
        <PageTitle />
      </div>
    </div>
  );
};

export default DashboardHeader;
